import styles from '../../../../components/advertiserBrand/styles.module.css'
import { ImportRowStatus } from '../../../../helpers/advertiserBrandImport'

const CHIP_CLASS: Record<ImportRowStatus, string> = {
  add: styles.chipAdd,
  link: styles.chipLink,
  move: styles.chipMove,
  unchanged: styles.chipMuted,
  error: styles.chipError,
  unknown: styles.chipLink
}

export const Chip: React.FC<{ tone: ImportRowStatus; label: string }> = ({
  tone,
  label
}) => (
  <span className={`${styles.chip} ${CHIP_CLASS[tone]}`}>
    <span className={styles.chipDot} aria-hidden="true" />
    {label}
  </span>
)
